import React from 'react'
import { useTranslation } from "react-i18next"

const CustomRender = ({ value }) => {
    const { t } = useTranslation();
    return t(value);
}

export default CustomRender;